import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Coins } from "@phosphor-icons/react";

export default function CurrencyPicker() {
  const { user, settings, setSettings } = useAuth();
  const [list, setList] = useState([]);
  const canEdit = user?.permissions?.includes("settings:manage");

  useEffect(() => {
    if (canEdit) api.get("/currencies").then(({ data }) => setList(data)).catch(() => {});
  }, [canEdit]);

  const change = async (code) => {
    try {
      const { data } = await api.put("/settings", { currency: code });
      setSettings(data);
      toast.success(`Stock values now shown in ${code}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    }
  };

  if (!canEdit) {
    return (
      <span data-testid="currency-badge" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground border border-border rounded-md px-3 py-1.5">
        <Coins size={16} /> {settings.currency}
      </span>
    );
  }
  return (
    <Select value={settings.currency} onValueChange={change}>
      <SelectTrigger className="w-44 gap-2" data-testid="currency-select">
        <Coins size={16} className="text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {list.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`currency-option-${c.code}`}>{c.code} · {c.symbol}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
